import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'src/app/services/toast.service';

export interface IVoidReasonData {
  voidReason: string;
}

export interface IVoidReasonResult {
  confirmed: boolean;
  voidReason?: string;
}

@Component({
  standalone: false,
  selector: 'app-void-reason-dialog',
  templateUrl: './void-reason-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./../../shared/form/form.component.scss']
})
export class VoidReasonDialogComponent {
  constructor(public dialogRef: MatDialogRef<VoidReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IVoidReasonData,
    private toastService: ToastService) {
  }

  onSave() {
    if (!this.data.voidReason || this.data.voidReason.trim().length === 0) {
      this.toastService.displayErrorMessage('Void reason is required', true);
      return;
    }
    this.dialogRef.close({ confirmed: true, voidReason: this.data.voidReason } as IVoidReasonResult);
  }

  onCancel() {
    this.dialogRef.close({ confirmed: false } as IVoidReasonResult);
  }
}
